import React, { useContext, useState, useEffect, useRef } from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import {  Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import { IconButton } from "@mui/material";
import { Groups, SaveAlt, Refresh } from "@mui/icons-material";

import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from '@material-ui/icons/Send';
import MessageIcon from '@material-ui/icons/Message';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import TimerIcon from '@material-ui/icons/Timer';
import * as XLSX from 'xlsx';

import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import TabPanel from "../../components/TabPanel"
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useContacts from "../../hooks/useContacts";
import useMessages from "../../hooks/useMessages";
import api from "../../services/api";
import { ChatsUser } from "./ChartsUser";
import ChartDonut from "./ChartDonut";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import { ChartsDate } from "./ChartsDate";
import { Avatar, Button, Card, CardContent, Container, Stack, SvgIcon, Tab, Tabs } from "@mui/material";
import { i18n } from "../../translate/i18n";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import ForbiddenPage from "../../components/ForbiddenPage";
import { ArrowDownward, ArrowUpward, Phone } from "@material-ui/icons";
import { TextField, FormControl, InputLabel, MenuItem, Select, Grid, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import whatsBackground from "../../assets/wa-background.png";
import whatsBackgroundDark from "../../assets/wa-background-dark.png";

const useStyles = makeStyles((theme) => ({
  overline: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: "grey",
    letterSpacing: '0.5px',
    lineHeight: 2.5,
    textTransform: 'uppercase',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 500,
    fontSize: '2rem',
    lineHeight: 1,
    color: "grey",
  },
  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },
    "&:hover": {
      backgroundColor: "rgba(6, 81, 131, 0.3)",
    },
    "&$selected": {
      color: "#FFF",
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabIndicator: {
    borderWidth: "2px",
    borderStyle: "solid",
    height: 6,
    bottom: 0,
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
    maxWidth: "1150px",
    minWidth: "xs",
  },
  nps: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  customFixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 120,
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  },
  fixedHeightPaper2: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  '@global': {
    '@keyframes pulse': {
      '0%': {
        opacity: 1,
      },
      '50%': {
        opacity: 0.5,
      },
      '100%': {
        opacity: 1,
      },
    },
  },
  messagesContainer: {
    display: "flex",
    flexDirection: "column",
    height: "400px",
    overflowY: "auto",
    padding: "8px",
    ...theme.scrollbarStyles,
  },
  ticketCard: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(1.5),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'box-shadow 0.2s ease-in-out',
    minWidth: '250px',
    maxWidth: '300px',
    display: 'inline-block',
    verticalAlign: 'top',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  ticketHeader: {
    marginBottom: theme.spacing(0.5),
  },
  ticketsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'flex-start',
  },
  contactName: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    color: theme.palette.primary.main,
  },
  contactPhone: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  lastMessageDate: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
    fontStyle: 'italic',
  },
  // Estilos EXATOS da tela de atendimentos (MessagesList)
  conversationContainer: {
    backgroundImage: theme.mode === 'light' ? `url(${whatsBackground})` : `url(${whatsBackgroundDark})`,
    backgroundColor: theme.mode === 'light' ? "transparent" : "#0b0b0d",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 30px 20px",
    overflowY: "scroll",
    maxHeight: '600px',
    ...theme.scrollbarStyles,
  },
  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    whiteSpace: "pre-wrap",
    backgroundColor: "#ffffff",
    color: "#303030",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
    boxShadow: "0 1px 1px #b3b3b3"
  },
  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    whiteSpace: "pre-wrap",
    backgroundColor: "#dcf8c6",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
    boxShadow: "0 1px 1px #b3b3b3"
  },
  messageBody: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px"
  },
  messageText: {
    flex: 1,
    maxWidth: 'calc(100% - 40px)', // Garante espaço para o horário
    wordBreak: 'break-word'
  },
  timestamp: {
    fontSize: "11px",
    color: "#999",
    whiteSpace: "nowrap"
  },
  // Estilos EXATOS para divisão de tickets da tela de atendimentos
  currentTick: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "auto",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "1px 5px 10px #b3b3b3",
  },
  currentTicktText: {
    color: "#ffffff",
    fontWeight: 'bold',
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },
  dailyTimestamp: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },
  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },
  timestamp: {
    fontSize: "11px",
    position: "absolute",
    bottom: "5px",
    right: "10px",
    color: "#999",
  },
  clickableNumber: {
    cursor: 'pointer',
    fontWeight: 600,
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));

const Dashboard = () => {
  const theme = useTheme();
  const classes = useStyles();
  const [counters, setCounters] = useState({});
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [dateFrom, setDateFrom] = useState(moment("1", "D").format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const { 
    find, 
    fetchData, 
    updateTimestamps, 
    attendants, 
    setAttendants,
    loading 
  } = useDashboard();

  //FILTROS NPS
  const [tab, setTab] = useState("Indicadores");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);



  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let nowIni = `${year}-${month < 10 ? `0${month}` : `${month}`}-01`;

  let now = `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [dateStartTicket, setDateStartTicket] = useState(nowIni);
  const [dateEndTicket, setDateEndTicket] = useState(now);
  const [queueTicket, setQueueTicket] = useState(false);
  const [fetchDataFilter, setFetchDataFilter] = useState(false);

  // Estados para filtro de atendentes
  const [selectedUserId, setSelectedUserId] = useState("");
  const [users, setUsers] = useState([]);

  // Estados para período de análise
  const [periodStart, setPeriodStart] = useState(moment().format("YYYY-MM-DD"));
  const [periodEnd, setPeriodEnd] = useState(moment().format("YYYY-MM-DD"));

  // Estado para controlar o recálculo manual
  const [statsVersion, setStatsVersion] = useState(0);

  // Estados para modais de tickets
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [loadingTickets, setLoadingTickets] = useState(false);

  // Estados para modal de conversa individual do ticket
  const [ticketViewModalOpen, setTicketViewModalOpen] = useState(false);
  const [selectedTicketData, setSelectedTicketData] = useState(null);
  const [loadingTicketData, setLoadingTicketData] = useState(false);

  // Cache para armazenar todos os logs da empresa
  const [allCompanyLogs, setAllCompanyLogs] = useState([]);
  const [logsLoaded, setLogsLoaded] = useState(false);

  const { user } = useContext(AuthContext);

  // Função para carregar todos os logs da empresa (otimizada - uma única requisição)
  const loadAllCompanyLogs = async () => {
    if (!user.companyId) return [];

    try {
      // Uma única requisição para todos os usuários da empresa
      const { data: logs } = await api.get('/tickets-logs', {
        params: {
          dateStart: periodStart,
          dateEnd: periodEnd,
          companyId: user.companyId
          // userId removido - pegará todos os usuários
        }
      });

      setAllCompanyLogs(logs);
      setLogsLoaded(true);
      return logs; // Retorna os dados diretamente
    } catch (error) {
      console.error("Erro ao carregar logs da empresa:", error);
      setAllCompanyLogs([]);
      setLogsLoaded(true);
      return []; // Retorna array vazio em caso de erro
    }
  };

  // Função OTIMIZADA para calcular estatísticas de TODOS os usuários de uma vez
  const calculateAllUsersStats = async (attendants) => {
    if (!user.companyId || !attendants || attendants.length === 0) {
      return {};
    }

    // Carrega todos os logs da empresa primeiro e usa os dados retornados
    const companyLogs = !logsLoaded ? await loadAllCompanyLogs() : allCompanyLogs;

    const allStats = {};

    // Processa estatísticas para cada usuário
    attendants.forEach(attendant => {
      const userId = attendant.id.toString();
      
      // Filtra logs apenas deste usuário dos dados carregados
      const userLogs = companyLogs.filter(log => log.userId === parseInt(userId));

      // Para tickets movimentados: contar apenas ticketIds únicos que tiveram mudança de STATUS (não tag)
      const statusLogs = userLogs.filter(log => log.type === "status" && log.status && log.status !== "pending");
      const uniqueTicketIds = [...new Set(statusLogs.map(log => log.ticketId))];
      const ticketsMovimentados = uniqueTicketIds.length;

      // Agrupar logs por ticket e contar status únicos seguindo o fluxo, guardando os IDs também
      const ticketStatusCount = { aceitos: 0, arquivados: 0, resolvidos: 0 };
      const ticketStatusIds = { aceitos: [], arquivados: [], resolvidos: [], movimentados: uniqueTicketIds };

      uniqueTicketIds.forEach(ticketId => {
        // Pegar todos os logs de status deste ticket, ordenados por data
        const ticketStatusLogs = userLogs
          .filter(log => log.ticketId === ticketId && log.type === "status" && log.status && log.status !== "pending")
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        // Implementar lógica de fluxo: open -> archived -> closed
        // Só conta cada status uma vez, seguindo a ordem do fluxo
        let hasOpen = false;
        let hasArchived = false;
        let hasClosed = false;

        ticketStatusLogs.forEach(log => {
          if (log.status === "open" && !hasOpen) {
            hasOpen = true;
            ticketStatusCount.aceitos++;
            ticketStatusIds.aceitos.push(ticketId);
          } else if (log.status === "archived" && hasOpen && !hasArchived) {
            // Só conta archived se já passou por open
            hasArchived = true;
            ticketStatusCount.arquivados++;
            ticketStatusIds.arquivados.push(ticketId);
          } else if (log.status === "closed" && hasOpen && !hasClosed) {
            // Só conta closed se já passou por open
            hasClosed = true;
            ticketStatusCount.resolvidos++;
            ticketStatusIds.resolvidos.push(ticketId);
          }
        });
      });

      allStats[userId] = {
        ticketsMovimentados,
        aceitos: ticketStatusCount.aceitos,
        arquivados: ticketStatusCount.arquivados,
        resolvidos: ticketStatusCount.resolvidos,
        ticketIds: ticketStatusIds,
      };
    });

    return allStats;
  };

  // Função para calcular estatísticas de tickets por usuário (mantida para compatibilidade)
  const calculateTicketStats = async (userId) => {
    if (!userId || !user.companyId) {
      return {
        ticketsMovimentados: 0,
        aceitos: 0,
        arquivados: 0,
        resolvidos: 0,
        ticketIds: {
          aceitos: [],
          arquivados: [],
          resolvidos: [],
          movimentados: []
        },
      };
    }

    try {
      // Carrega todos os logs da empresa primeiro e usa os dados retornados
      const companyLogs = !logsLoaded ? await loadAllCompanyLogs() : allCompanyLogs;
      
      // Filtra logs apenas deste usuário dos dados carregados
      const userLogs = companyLogs.filter(log => log.userId === parseInt(userId));

      // Para tickets movimentados: contar apenas ticketIds únicos que tiveram mudança de STATUS (não tag)
      const statusLogs = userLogs.filter(log => log.type === "status" && log.status && log.status !== "pending");
      const uniqueTicketIds = [...new Set(statusLogs.map(log => log.ticketId))];
      const ticketsMovimentados = uniqueTicketIds.length;

      // Agrupar logs por ticket e contar status únicos seguindo o fluxo, guardando os IDs também
      const ticketStatusCount = { aceitos: 0, arquivados: 0, resolvidos: 0 };
      const ticketStatusIds = { aceitos: [], arquivados: [], resolvidos: [], movimentados: uniqueTicketIds };

      uniqueTicketIds.forEach(ticketId => {
        // Pegar todos os logs de status deste ticket, ordenados por data
        const ticketStatusLogs = userLogs
          .filter(log => log.ticketId === ticketId && log.type === "status" && log.status && log.status !== "pending")
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        // Implementar lógica de fluxo: open -> archived -> closed
        // Só conta cada status uma vez, seguindo a ordem do fluxo
        let hasOpen = false;
        let hasArchived = false;
        let hasClosed = false;

        ticketStatusLogs.forEach(log => {
          if (log.status === "open" && !hasOpen) {
            hasOpen = true;
            ticketStatusCount.aceitos++;
            ticketStatusIds.aceitos.push(ticketId);
          } else if (log.status === "archived" && hasOpen && !hasArchived) {
            // Só conta archived se já passou por open
            hasArchived = true;
            ticketStatusCount.arquivados++;
            ticketStatusIds.arquivados.push(ticketId);
          } else if (log.status === "closed" && hasOpen && !hasClosed) {
            // Só conta closed se já passou por open
            hasClosed = true;
            ticketStatusCount.resolvidos++;
            ticketStatusIds.resolvidos.push(ticketId);
          }
        });
      });

      return {
        ticketsMovimentados,
        aceitos: ticketStatusCount.aceitos,
        arquivados: ticketStatusCount.arquivados,
        resolvidos: ticketStatusCount.resolvidos,
        ticketIds: ticketStatusIds,
      };
    } catch (error) {
      console.error("Erro ao processar logs de tickets:", error);
      return {
        ticketsMovimentados: 0,
        aceitos: 0,
        arquivados: 0,
        resolvidos: 0,
        ticketIds: {
          aceitos: [],
          arquivados: [],
          resolvidos: [],
          movimentados: []
        },
      };
    }
  };

  // Função para forçar recálculo das estatísticas (otimizada)
  const handleRecalculateStats = () => {
    setLogsLoaded(false); // Força recarregamento dos logs na próxima chamada
    setStatsVersion(prev => prev + 1);
  };

  // Invalidar cache quando datas mudarem
  useEffect(() => {
    setLogsLoaded(false);
    setAllCompanyLogs([]);
  }, [periodStart, periodEnd]);

  // Função para buscar detalhes dos tickets
  const fetchTicketsData = async (ticketIds) => {
    try {
      const response = await api.post('/tickets/details', {
        ticketIds: ticketIds
      });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar detalhes dos tickets:", error);
      return [];
    }
  };

  // Função para abrir modal de tickets
  const handleOpenTicketModal = async (ticketIds, title, userId) => {
    if (!ticketIds || ticketIds.length === 0) return;
    
    setModalTitle(title);
    setTicketModalOpen(true);
    setLoadingTickets(true);
    
    const ticketsData = await fetchTicketsData(ticketIds);
    setSelectedTickets(ticketsData);
    setLoadingTickets(false);
  };

  // Função para fechar modal de tickets
  const handleCloseTicketModal = () => {
    setTicketModalOpen(false);
    setSelectedTickets([]);
    setModalTitle('');
  };

  // Função para buscar detalhes completos de um ticket específico e mensagens do contato
  const fetchTicketDetails = async (ticketId) => {
    try {
      // Buscar dados básicos do ticket
      const ticketResponse = await api.get(`/tickets/${ticketId}`);
      
      // Buscar mensagens do contato (todas as mensagens do contato, não apenas do ticket específico)
      const messagesResponse = await api.get(`/messages/${ticketId}`);
      
      // Combinar os dados
      return {
        ...ticketResponse.data,
        messages: messagesResponse.data.messages || [],
        contactId: ticketResponse.data.contact?.id
      };
    } catch (error) {
      console.error("Erro ao buscar detalhes do ticket:", error);
      return null;
    }
  };

  // Função para abrir modal de conversa do ticket
  const handleOpenTicketView = async (ticketId) => {
    setTicketViewModalOpen(true);
    setLoadingTicketData(true);
    
    const ticketData = await fetchTicketDetails(ticketId);
    setSelectedTicketData(ticketData);
    setLoadingTicketData(false);
  };

  // Função para fechar modal de conversa do ticket
  const handleCloseTicketView = () => {
    setTicketViewModalOpen(false);
    setSelectedTicketData(null);
  };

  // Função para fazer scroll para o final da conversa
  const scrollToBottom = () => {
    const conversationContainer = document.querySelector('.conversationContainer');
    if (conversationContainer) {
      conversationContainer.scrollTop = conversationContainer.scrollHeight;
    }
  };

  const conversationEndRef = useRef(null);
  const conversationContainerRef = useRef(null);

  // useEffect para mostrar IMEDIATAMENTE a última mensagem quando a conversa abrir
  useEffect(() => {
    if (selectedTicketData && selectedTicketData.messages && selectedTicketData.messages.length > 0) {
      // Múltiplas tentativas para garantir que funcione em TODAS as conversas (incluindo mídias)
      const scrollToLastMessage = () => {
        if (conversationContainerRef.current) {
          conversationContainerRef.current.scrollTop = conversationContainerRef.current.scrollHeight;
        }
        if (conversationEndRef.current) {
          conversationEndRef.current.scrollIntoView({ behavior: 'auto' });
        }
      };
      
      // Executar imediatamente
      scrollToLastMessage();
      
      // Executar após pequenos delays para garantir que mídias carreguem
      setTimeout(scrollToLastMessage, 50);
      setTimeout(scrollToLastMessage, 150);
      setTimeout(scrollToLastMessage, 300);
    }
  }, [selectedTicketData]);

  // Função para renderizar divisões entre tickets (baseada na tela de atendimentos)
  const renderTicketsSeparator = (message, index, messagesList) => {
    let lastTicket = messagesList[index - 1]?.ticketId;
    let currentTicket = message.ticketId;

    if (lastTicket !== currentTicket && lastTicket !== undefined) {
      const queueColor = message?.ticket?.queue?.color || "#999";
      const queueName = message?.ticket?.queue?.name || i18n.t("ticketsList.noQueue");
      
      return (
        <div className={classes.currentTick} key={`separator-${message.id}`} style={{ backgroundColor: queueColor }}>
          <div className={classes.currentTicktText}>
            #{i18n.t("ticketsList.called")} {message.ticketId} - {queueName}
          </div>
        </div>
      );
    }
    return null;
  };

  // Função para renderizar timestamps de data (como badge azul centralizado na tela de atendimentos)
  const renderDailyTimestamps = (message, index, messagesList) => {
    const currentDate = moment(message.createdAt).format('YYYY-MM-DD');
    const previousDate = index > 0 ? moment(messagesList[index - 1].createdAt).format('YYYY-MM-DD') : null;
    
    if (index === 0 || currentDate !== previousDate) {
      return (
        <span className={classes.dailyTimestamp} key={`date-${message.id}`}>
          <div className={classes.dailyTimestampText}>
            {moment(message.createdAt).format('DD/MM/YYYY')}
          </div>
        </span>
      );
    }
    return null;
  };

  // Carregar lista de usuários
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await api.get("/users/list");
        setUsers(data);
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
      }
    };
    fetchUsers();
  }, []);



  // Filtrar attendants por usuário selecionado
  const getFilteredAttendants = () => {
    if (!selectedUserId) {
      return attendants;
    }
    return attendants.filter(attendant => attendant.id.toString() === selectedUserId);
  };



  const exportarGridParaExcel = () => {
    const ws = XLSX.utils.table_to_sheet(document.getElementById('grid-attendants'));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'RelatorioDeAtendentes');
    XLSX.writeFile(wb, 'relatorio-de-atendentes.xlsx');
  };

  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    async function firstLoad() {
      await loadDashboardData();
    }
    setTimeout(() => {
      firstLoad();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDataFilter]);

  async function loadDashboardData() {
    let params = {};

    if (period > 0) {
      params = {
        days: period,
      };
    }

    if (!isEmpty(dateStartTicket) && moment(dateStartTicket).isValid()) {
      params = {
        ...params,
        date_from: moment(dateStartTicket).format("YYYY-MM-DD"),
      };
    }

    if (!isEmpty(dateEndTicket) && moment(dateEndTicket).isValid()) {
      params = {
        ...params,
        date_to: moment(dateEndTicket).format("YYYY-MM-DD"),
      };
    }

    if (Object.keys(params).length === 0) {
      toast.error("Parametrize o filtro");
      return;
    }

    try {
      const data = await fetchData(params);
    setCounters(data.counters);
    } catch (error) {
      console.error("Erro ao carregar dados do dashboard:", error);
    }
  }

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);
    setSelectedUsers(users);
  };


  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  function formatTime(minutes) {
    return moment()
      .startOf("day")
      .add(minutes, "minutes")
      .format("HH[h] mm[m]");
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach(user => {
      if (user.online === true) {
        userOnline = userOnline + 1
      }
    })
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  const GetContacts = (all) => {
    let props = {};
    if (all) {
      props = {};
    } else {
      props = {
        dateStart: dateStartTicket,
        dateEnd: dateEndTicket,
      };
    }
    const { count } = useContacts(props);
    return count;
  };

  const GetMessages = (all, fromMe) => {
    let props = {};
    if (all) {
      if (fromMe) {
        props = {
          fromMe: true
        };
      } else {
        props = {
          fromMe: false
        };
      }
    } else {
      if (fromMe) {
        props = {
          fromMe: true,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      } else {
        props = {
          fromMe: false,
          dateStart: dateStartTicket,
          dateEnd: dateEndTicket,
        };
      }
    }
    const { count } = useMessages(props);
    return count;
  };

  function toggleShowFilter() {
    setShowFilter(!showFilter);
  }

  return (
    <>
      {
        user.profile === "user" && user.showDashboard === "disabled" ?
          <ForbiddenPage />
          :
          <>
            <div>
              <Container maxWidth="lg" className={classes.container}>
                <Grid2 container spacing={3} className={classes.container}>

                  {/* FILTROS */}
                  <Grid2 xs={12}>
                    <Button
                      onClick={toggleShowFilter}
                      style={{ float: "right" }}
                      color="primary"
                    >
                      {!showFilter ? (
                        <FilterListIcon />
                      ) : (
                        <ClearIcon />
                      )}
                    </Button>
                  </Grid2>

                  {showFilter && (
                    <Filters
                      classes={classes}
                      setDateStartTicket={setDateStartTicket}
                      setDateEndTicket={setDateEndTicket}
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      setQueueTicket={setQueueTicket}
                      queueTicket={queueTicket}
                      fetchData={setFetchDataFilter}
                    />
                  )}

                  <Grid2 container width="100%" justifyContent="center">
                    <Tabs
                      value={tab}
                      onChange={handleChangeTab}
                      variant="fullWidth"
                      indicatorColor="primary"
                      textColor="primary"
                      aria-label="icon label tabs example"
                      classes={{ indicator: classes.tabIndicator }}
                      sx={{
                        borderRadius: "5px",
                        borderColor: "#aaa",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        fontFamily: '"Plus Jakarta Sans", sans-serif',
                      }}
                    >
                      <Tab classes={{ root: classes.tab }}
                        style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#FFF" }}
                        value="Indicadores"
                        label={i18n.t("dashboard.tabs.indicators")}
                      />
                      <Tab classes={{ root: classes.tab }}
                        style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#FFF" }}
                        value="NPS"
                        label={i18n.t("dashboard.tabs.assessments")}
                      />
                      <Tab classes={{ root: classes.tab }}
                        style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#FFF" }}
                        value="Atendentes"
                        label={i18n.t("dashboard.tabs.attendants")}
                      />
                    </Tabs>
                  </Grid2>
                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={"Indicadores"}
                  >
                    <Container maxWidth="xl" >
                      <Grid2
                        container
                        spacing={3}
                      >
                        {/* EM ATENDIMENTO */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.inAttendance")}
                                  </Typography>
                                  <Typography variant="h4" className={classes.h4}>
                                    {counters.supportHappening}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#0b708c',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <CallIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* AGUARDANDO */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.waiting")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {counters.supportPending}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#47606e',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <HourglassEmptyIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* FINALIZADOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.finalized")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {counters.supportFinished}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#5852ab',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <CheckCircleIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* GRUPOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.groups")}
                                  </Typography>
                                  <Typography variant="h4"

                                    className={classes.h4}
                                  >
                                    {counters.supportGroups}
                                  </Typography>
                                </Stack>

                                <Avatar
                                  sx={{
                                    backgroundColor: '#01BBAC',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <Groups />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* ATENDENTES ATIVOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.activeAttendants")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {GetUsers()}/{attendants.length}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#805753',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <RecordVoiceOverIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* NOVOS CONTATOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.newContacts")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {counters.leads}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#8c6b19',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <GroupAddIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* MINHAS MENSAGEM RECEBIDAS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.totalReceivedMessages")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {GetMessages(false, false)}/{GetMessages(true, false)}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#333133',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <MessageIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* MINHAS MENSAGEM ENVIADAS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.totalSentMessages")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {GetMessages(false, true)}/{GetMessages(true, true)}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#558a59',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <SendIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* T.M. DE ATENDIMENTO */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.averageServiceTime")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {formatTime(counters.avgSupportTime)}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#F79009',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <AccessAlarmIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* T.M. DE ESPERA */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.averageWaitingTime")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {formatTime(counters.avgWaitTime)}
                                  </Typography>
                                </Stack>
                                <Avatar
                                  sx={{
                                    backgroundColor: '#8a2c40',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <TimerIcon />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* TICKETS ATIVOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.activeTickets")}
                                  </Typography>
                                  <Typography variant="h4"
                                    className={classes.h4}
                                  >
                                    {counters.activeTickets}
                                  </Typography>
                                </Stack>

                                <Avatar
                                  sx={{
                                    backgroundColor: '#EE4512',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <ArrowUpward />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>

                        {/* TICKETS PASSIVOS */}
                        <Grid2 xs={12}
                          sm={6}
                          lg={4}
                        >
                          <Card sx={{
                            height: "100%",
                            backgroundColor:
                              theme.mode === "light"
                                ? "transparent"
                                : "rgba(170, 170, 170, 0.2)",
                          }}>
                            <CardContent>
                              <Stack
                                alignItems="flex-start"
                                direction="row"
                                justifyContent="space-between"
                                spacing={3}
                              >
                                <Stack spacing={1}>
                                  <Typography
                                    color="primary"
                                    variant="overline"
                                    className={classes.overline}
                                  >
                                    {i18n.t("dashboard.cards.passiveTickets")}
                                  </Typography>
                                  <Typography variant="h4"

                                    className={classes.h4}
                                  >
                                    {counters.passiveTickets}
                                  </Typography>
                                </Stack>


                                <Avatar
                                  sx={{
                                    backgroundColor: '#28C037',
                                    height: 60,
                                    width: 60
                                  }}
                                >
                                  <SvgIcon>
                                    <ArrowDownward />
                                  </SvgIcon>
                                </Avatar>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid2>
                      </Grid2>
                    </Container>
                  </TabPanel>

                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={"NPS"}
                  >
                    <Grid2 className={classes.container}>
                      <Grid2 container width="100%" spacing={2}>

                        <Grid2 xs={12} sm={6} md={3}>
                          <Paper elevation={3} >
                            <ChartDonut
                              data={[`{'name': 'Promotores', 'value': ${counters.npsPromotersPerc | 100}}`,
                              `{'name': 'Detratores', 'value': ${counters.npsDetractorsPerc | 0}}`,
                              `{'name': 'Neutros', 'value': ${counters.npsPassivePerc | 0}}`
                              ]}
                              value={counters.npsScore | 0}
                              title="Score"
                              color={(parseInt(counters.npsPromotersPerc | 0) + parseInt(counters.npsDetractorsPerc | 0) + parseInt(counters.npsPassivePerc | 0)) === 0 ? ["#918F94"] : ["#2EA85A", "#F73A2C", "#F7EC2C"]}
                            />
                          </Paper>
                        </Grid2>

                        <Grid2 xs={12} sm={6} md={3}>
                          <Paper elevation={3}>
                            <ChartDonut
                              title={i18n.t("dashboard.assessments.prosecutors")}
                              value={counters.npsPromotersPerc | 0}
                              data={[`{'name': 'Promotores', 'value': 100}`]}
                              color={["#2EA85A"]}
                            />
                          </Paper>
                        </Grid2>

                        <Grid2 xs={12} sm={6} md={3}>
                          <Paper elevation={3} >
                            <ChartDonut
                              data={[`{'name': 'Neutros', 'value': 100}`]}
                              title={i18n.t("dashboard.assessments.neutral")}
                              value={counters.npsPassivePerc | 0}
                              color={["#F7EC2C"]}
                            />
                          </Paper>
                        </Grid2>

                        <Grid2 xs={12} sm={6} md={3}>
                          <Paper elevation={3}>
                            <ChartDonut
                              data={[`{'name': 'Detratores', 'value': 100}`]}
                              title={i18n.t("dashboard.assessments.detractors")}
                              value={counters.npsDetractorsPerc | 0}
                              color={["#F73A2C"]}
                            />
                          </Paper>
                        </Grid2>

                        <Grid2 xs={12} sm={6} md={12}>
                          <Paper elevation={3}>
                            <Typography
                              component="h3"
                              variant="h6"
                              paragraph
                              style={{ marginLeft: "10px" }}
                            >
                              {i18n.t("dashboard.assessments.totalCalls")}: {counters.tickets} <br></br>
                              {i18n.t("dashboard.assessments.callsWaitRating")}: {counters.waitRating} <br></br>
                              {i18n.t("dashboard.assessments.callsWithoutRating")}: {counters.withoutRating} <br></br>
                              {i18n.t("dashboard.assessments.ratedCalls")}: {counters.withRating} <br></br>
                              {i18n.t("dashboard.assessments.evaluationIndex")}: {Number(counters.percRating / 100).toLocaleString(undefined, { style: 'percent' })} <br></br>
                            </Typography>
                          </Paper>
                        </Grid2>

                      </Grid2>
                    </Grid2>

                  </TabPanel>

                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={"Atendentes"}
                  >
                    <Container width="100%" className={classes.container}>

                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                      <IconButton onClick={exportarGridParaExcel} aria-label="Exportar para Excel">
                        <SaveAlt />
                      </IconButton>
                          <IconButton 
                            onClick={loadDashboardData} 
                            aria-label="Atualizar dados"
                            disabled={loading}
                          >
                            <Refresh />
                          </IconButton>
                        </div>

                      </div>

                      <Grid2 container width="100%">
                        {/* CARD DE GRAFICO */}
                        {/* <Grid2 item xs={12}>
                  <Paper
                    elevation={6}
                    className={classes.fixedHeightPaper}
                  >
                    <Chart
                      dateStartTicket={dateStartTicket}
                      dateEndTicket={dateEndTicket}
                      queueTicket={queueTicket}
                    />
                  </Paper>
                </Grid2>  */}

                        {/* INFO DOS USUARIOS */}
                        <Grid2 xs={12} id="grid-attendants">
                          <Paper className={classes.fixedHeightPaper2}>
                            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                              {i18n.t("dashboard.tabs.attendants")}
                            </Typography>
                            
                                                      <Grid container spacing={2} style={{ marginBottom: '16px' }}>
                            <Grid item>
                              <FormControl style={{ minWidth: 200 }}>
                                <InputLabel id="user-select-label">
                                  Selecione um usuário
                                </InputLabel>
                                <Select
                                  labelId="user-select-label"
                                  id="user-select"
                                  value={selectedUserId}
                                  onChange={(e) => setSelectedUserId(e.target.value)}
                                >
                                  <MenuItem value="">
                                    Todos os usuários
                                  </MenuItem>
                                  {users.map((user) => (
                                    <MenuItem key={user.id} value={user.id.toString()}>
                                      {user.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item>
                              <TextField
                                label="Data Início"
                                type="date"
                                value={periodStart}
                                onChange={(e) => setPeriodStart(e.target.value)}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                style={{ minWidth: 150 }}
                              />
                            </Grid>
                            <Grid item>
                              <TextField
                                label="Data Fim"
                                type="date"
                                value={periodEnd}
                                onChange={(e) => setPeriodEnd(e.target.value)}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                style={{ minWidth: 150 }}
                              />
                            </Grid>
                            <Grid item>
                              <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={handleRecalculateStats}
                                style={{ backgroundColor: theme.palette.primary.main, color: '#fff' }}
                              >
                                Calcular
                              </Button>
                            </Grid>
                          </Grid>

                            {getFilteredAttendants().length ? (
                              <div style={{ marginTop: '16px' }}>
                            <TableAttendantsStatus
                                  attendants={getFilteredAttendants()}
                              loading={loading}
                                  calculateTicketStats={calculateTicketStats}
                                  calculateAllUsersStats={calculateAllUsersStats}
                                  periodStart={periodStart}
                                  periodEnd={periodEnd}
                                  statsVersion={statsVersion}
                                  onOpenTicketModal={handleOpenTicketModal}
                                />
                              </div>
                          ) : null}
                          </Paper>
                        </Grid2>

                        {/* TOTAL DE ATENDIMENTOS POR USUARIO */}
                        <Grid2 xs={12} id="grid-attendants">
                          <Paper className={classes.fixedHeightPaper2}>
                            <ChatsUser />
                          </Paper>
                        </Grid2>

                        {/* TOTAL DE ATENDIMENTOS */}
                        <Grid2 xs={12} id="grid-attendants">
                          <Paper className={classes.fixedHeightPaper2}>
                            <ChartsDate />
                          </Paper>
                        </Grid2>
                      </Grid2>
                    </Container>
                  </TabPanel>
                </Grid2>
              </Container >
            </div >
          </>
      }

      {/* Modal de Tickets */}
      <Dialog
        open={ticketModalOpen}
        onClose={handleCloseTicketModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {modalTitle} ({selectedTickets.length} tickets)
        </DialogTitle>
        <DialogContent style={{ maxHeight: '500px', overflow: 'auto' }}>
          {loadingTickets ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              Carregando tickets...
            </div>
          ) : (
            <div className={classes.ticketsContainer}>
              {selectedTickets.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', width: '100%' }}>
                  Nenhum ticket encontrado
                </div>
              ) : (
                selectedTickets.map((ticket) => (
                  <Card 
                    key={ticket.id} 
                    className={classes.ticketCard}
                    onClick={() => handleOpenTicketView(ticket.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className={classes.ticketHeader}>
                      <div className={classes.contactName}>
                        {ticket.contactName}
                      </div>
                      <div className={classes.contactPhone}>
                        <Phone fontSize="small" />
                        {ticket.contactNumber}
                      </div>
                    </div>
                    <div className={classes.lastMessageDate}>
                      Última mensagem: {moment(ticket.lastMessageDate).format('DD/MM/YYYY HH:mm')}
                    </div>
                  </Card>
                ))
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTicketModal} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Conversa do Ticket */}
      <Dialog
        open={ticketViewModalOpen}
        onClose={handleCloseTicketView}
        maxWidth="sm"
        fullWidth={false}
        PaperProps={{
          style: { borderRadius: 16, minWidth: 400, maxWidth: 600, overflow: 'visible' }
        }}
      >
        <DialogTitle>
          {selectedTicketData ? `Conversa - ${selectedTicketData.contact?.name}` : 'Carregando...'}
        </DialogTitle>
        <DialogContent style={{ overflow: 'visible', padding: 0, maxHeight: 'none' }}>
          {loadingTicketData ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              Carregando conversa...
            </div>
          ) : selectedTicketData ? (
            <div style={{ display: 'flex', flexDirection: 'column', background: 'transparent' }}>
              <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                <strong>Contato:</strong> {selectedTicketData.contact?.name}<br/>
                <strong>Telefone:</strong> {selectedTicketData.contact?.number}<br/>
              </div>
              {selectedTicketData.messages && selectedTicketData.messages.length > 0 ? (
                <div className={classes.conversationContainer} ref={conversationContainerRef} style={{ flex: 1, minHeight: 0, maxHeight: 400 }}>
                  {selectedTicketData.messages.map((message, index) => {
                    const messagesList = selectedTicketData.messages;
                    return (
                      <React.Fragment key={`message-${message.id || index}`}>
                        {renderDailyTimestamps(message, index, messagesList)}
                        {renderTicketsSeparator(message, index, messagesList)}
                        <div 
                          className={message.fromMe ? classes.messageRight : classes.messageLeft}
                        >
                          <div className={classes.messageBody}>
                            <div className={classes.messageText}>{message.body}</div>
                            <div className={classes.timestamp}>
                              {moment(message.createdAt).format('HH:mm')}
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                  <div ref={conversationEndRef} />
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                  Nenhuma mensagem encontrada
                </div>
              )}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              Erro ao carregar dados do ticket
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTicketView} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Dashboard;
